<template>
  <div style="display: flex;flex-wrap: wrap;">
    <div class="common-btn research-font-color" @click="$emit('goToInvoice')" v-if="showInvoiceBtn">开票信息</div>
    <div class="common-btn research-font-color" @click="$emit('goToCustomerGoods')" v-if="showCustomerGoodsBtn">实物信息</div>
  </div>
</template>

<script>
// import EMKT from '../../constant'

export default {
  name: 'GcOrderDetailButtonsBase',
  emits: ['goToInvoice', 'goToCustomerGoods'],
  props: {
    orderDetail: Object,
    showCustomerGoodsBtn: Boolean,
    showInvoiceBtn: Boolean
  },
  methods: {}
}
</script>

<style scoped>
.common-btn {
  width: 73px;
  height: 26px;
  border-radius: 44px;
  line-height: 26px;
  text-align: center;
  font-size: 12px;
  background-color: #fff;
  border: 1px solid #5878fa;
  margin-left: 10px;
}

</style>



// WEBPACK FOOTER //
// GcOrderDetailButtonsBase.vue?eab633ae